import React from 'react';
import Primary from '../views/Primary/Primary';

const routes = {
    "/": () => <Primary />
};

export default routes;